// extracted by mini-css-extract-plugin
export default {"layoutComponent":"styles_layoutComponent__uH1zE","layoutComponent_sidebar":"styles_layoutComponent_sidebar__UwE+n"};